import { useQuery } from "@tanstack/react-query";
import { GroupVisit, GroupVisitControllerApi } from "@/services";
import { getConfigObject, getXtenantId } from "@/utils/utils";

export const GROUP_VISIT_DETAIL_QUERY_KEY = "group-visit-detail";

/**
 * Saved group behind the edit screen — the same payload shape `PUT` expects,
 * so an update can be built by merging the edits onto it.
 *
 * @author Rajkumar Rathod
 */
export const useGroupVisitById = (groupVisitId?: string) =>
  useQuery({
    queryKey: [GROUP_VISIT_DETAIL_QUERY_KEY, groupVisitId],
    enabled: !!groupVisitId,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new GroupVisitControllerApi(getConfigObject())
        .getGroupVisitById(groupVisitId as string, getXtenantId())
        .then((res) => res?.data?.data as GroupVisit),
  });
